import React, { useEffect, useState } from 'react'
import { Panel } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'
import { PanelHeader } from '../panels'
import { HolderIcon } from '../icons'
import { useParams } from 'react-router-dom'
import { useEnvironment } from '../../hooks/useEnvironment'
import { useRequestsEvents } from '../../hooks/useRequestsEvents'
import { EmptyResult, ErrorResult, LoaderBackDrop } from '../feedbacks'
import { PromotionPersonTable } from './tables/PromotionPersonTable'
import _ from 'lodash'

export const PromotionPersonHolderPanel = (props) => {
  // get current promotion id
  const { promotionId } = useParams()
  // for get promotions
  const { getPromotionHolder } = useRequestsEvents()
  // get permissions
  const { hasPromotionPermissions } = useEnvironment()
  // component config
  const [componentCfg, setComponentCfg] = useState({
    data: {},
    isLoaded: false,
    isError: false,
    isForbidden: false
  }) // set permissions
  const hasReadHolderPromotionPermission = hasPromotionPermissions(promotionId, 'read:promotion:holder') && !componentCfg.isForbidden
  const hasUpdateHolderPromotionPermission = hasPromotionPermissions(promotionId, 'update:promotion:holder') && !componentCfg.isForbidden
  const hasDeleteHolderPromotionPermission = hasPromotionPermissions(promotionId, 'delete:promotion:holder') && !componentCfg.isForbidden

  // for load all promotions data when component is mounted
  useEffect(() => {
    // clean up controller --> prevent crash with async function
    let isMounted = true
    // not reload if component is loaded...
    if (componentCfg.isLoaded) { return }
    // if not has permissions
    if (!hasReadHolderPromotionPermission) {
      setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data: {} })
    } else {
      // get promotion holder data
      getPromotionHolder(promotionId, (result) => {
        // prevent async crash
        if (!isMounted) return null
        // get holder data
        const data = result.data
        // set holder data
        setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data, isForbidden: false })
      }, (err) => {
        // prevent async crash
        if (!isMounted) return null
        if (err === 403) {
          setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data: {}, isForbidden: true })
        } else {
          setComponentCfg({ ...componentCfg, isError: true, isLoaded: true, data: {}, isForbidden: false })
        }
      })
    } // prevent crash with async function
    return () => { isMounted = false }
  }, [componentCfg.isLoaded])

  return (<>
    {(() => { /* check permissions */
      if (!hasReadHolderPromotionPermission || _.isEmpty(componentCfg.data)) {
        return <></>
      } else { /* render a panel */
        return (
          <Panel bodyFill header={
            <PanelHeader icon={<HolderIcon />} title={'dashboard.promotion.holder'} hasEdit={hasUpdateHolderPromotionPermission} hasDelete={hasDeleteHolderPromotionPermission} />
          }>
            <LoaderBackDrop active={!componentCfg.isLoaded} loader background bordered>
              <Panel className={'filled-table-panel'} style={{ borderRadius: '4px' }} bordered bodyFill>
                  { /* load component */ }
                  {(() => {
                    if (componentCfg.isError) {
                      return <ErrorResult compact={true}/>
                    } else if (_.isEmpty(componentCfg.data)) {
                      return <EmptyResult compact={true} />
                    } else { /* return components to render */
                      return <PromotionPersonTable data={componentCfg.data}/>
                    }
                  })()}
              </Panel>
            </LoaderBackDrop>
          </Panel>
        )
      }
    })()}
  </>)
}
